// extracted by mini-css-extract-plugin
export var orderSummary = "_qw-0";
export var showMoreLessButton = "_qw-1";